import {Component, Input} from '@angular/core';
import {MpAllergenXBVO, MpComponentXBVO, MpDesignationXBVO, MpNutritionsXBVO} from "../../model/xbvo.model";
import {BaseComponent} from "../../base/base.component";

/**
 * App-Component
 */
@Component({
    selector: '<menu-components>',
    template: `
        <div class="EmptyBox1 GrayBack"></div>
        <div class="YellowBack" style="padding: 2px 0 4px 4px;">{{v('menuComponents')}}</div>
        <div class="EmptyBox5"></div>
        <div *ngFor="let pComponent of modelComponents">
            
            <!-- header with image -->
            <div class="d-flex-stretch">
                <div>
                    <img [src]="pComponent.imageUrl" *ngIf="pComponent.imageUrl" (error)="handleMissingImage($event)" [width]="88" [height]="60" class="MarAll" style="border-radius: 8px;"/>
                    <img src="assets/icons/meal.svg" *ngIf="!pComponent.imageUrl" [width]="88" [height]="60" class="MarAll" style="border-radius: 8px;"/>
                </div>
                <!-- menu names -->
                <div class="d-col SoftYellowBack">
                    <div class="PadAll"><b>{{pComponent.designation}}</b></div>
                </div>
            </div>
            <allergens [modelRows]="pComponent.allergen"></allergens>
            <additives [modelRows]="pComponent.additive"></additives>
            <nutritions [modelNutritions]="pComponent.nutritions"></nutritions>
            <div class="EmptyBox20"></div>
        </div>
        
    `
})
export class ComponentsComponent extends BaseComponent {

    @Input()
    modelComponents: MpComponentXBVO[] = [];

}
